import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import type { BeneficiariesModel } from 'src/tpbp-json-api-handler/models/models'

export type BeneficiariesModelKey = keyof Pick<
  BeneficiariesModel,
  'bareOwnership' | 'fullOwnership' | 'usufruct'
>

const beneficiariesFields: FieldInterface[] = [
  {
    key: 'personId',
    originKey: 'person_id',
    type: FIELD_TYPES.string,
  },
  {
    key: 'bareOwnership',
    originKey: 'bare_ownership',
    type: FIELD_TYPES.object,
    objectType: 'BeneficiaryOwnership',
    objectTypePath: 'src/tpbp-core/models/beneficiary/beneficiaries.types',
  },
  {
    key: 'fullOwnership',
    originKey: 'full_ownership',
    type: FIELD_TYPES.object,
    objectType: 'BeneficiaryOwnership',
    objectTypePath: 'src/tpbp-core/models/beneficiary/beneficiaries.types',
  },
  {
    key: 'usufruct',
    originKey: 'usufruct',
    type: FIELD_TYPES.object,
    objectType: 'BeneficiaryOwnership',
    objectTypePath: 'src/tpbp-core/models/beneficiary/beneficiaries.types',
  },
]

const beneficiariesRelations: RelationInterface[] = [
  {
    key: '_portfolios',
    originKey: 'portfolios',
    objectType: OBJECT_TYPES.portfolio,
    isMultiple: false,
  },
  {
    key: '_person',
    originKey: 'person',
    objectType: OBJECT_TYPES.person,
    isMultiple: false,
  },
]

export { beneficiariesFields, beneficiariesRelations }
